import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { Alert, Button } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';
import ProjectGalleryCard from '../project-gallery-card';

const ProjectGalleryGrid = ({ projects, projectsToShow = 6, className, onLoadMoreClick }) => {
	const renderColumn = (col, screen = 'mobile') => {
		const filterOnTablet = (index) => (col === 0 ? index % 2 === 0 : index % 2 !== 0);
		const filterOnDesktop = (index) => index === col || (index - col) % 3 === 0;

		return (
			<div
				key={`column-${col}`}
				data-testid={`column-${screen}`}
				className='flex-12/12 space-y-4 md:flex-6/12 xl:flex-1'
			>
				{projects
					.slice(0, projectsToShow)
					.filter((_, index) => (screen === 'desktop' ? filterOnDesktop(index) : screen === 'tablet' ? filterOnTablet(index) : true))
					.map((project, projIndex) => {
						const isBeforeAfter = project.modular_blocks?.find((block) => block.all_images != null)?.all_images?.image?.length > 1;
						const cardSize = isBeforeAfter ? 'sm' : col === 1 ? (projIndex % 2 !== 0 ? 'lg' : 'sm') : projIndex % 2 === 0 ? 'lg' : 'sm';

						return (
							<ProjectGalleryCard
								key={`project-${projIndex}`}
								data={project}
								size={cardSize}
							/>
						);
					})}
			</div>
		);
	};

	return (
		<div
			className={`projectGalleryGrid ${className || ''}`}
			data-testid='project-gallery-grid'
		>
			{!isValidArray(projects) && (
				<Alert
					type='info'
					hideClose
				>
					No projects were found.
				</Alert>
			)}

			{isValidArray(projects) && (
				<div className='relative flex flex-row flex-wrap md:-mx-2 md:flex-1 md:[&>*]:px-2'>
					{projectsToShow <= projects.length && <div className='absolute bottom-0 left-0 z-2 h-[192px] w-full bg-gradient-to-t from-white to-transparent md:h-[336px]' />}

					<MediaQuery minWidth={1280}>{Array.from({ length: 3 }).map((_, index) => renderColumn(index, 'desktop'))}</MediaQuery>
					<MediaQuery
						minWidth={768}
						maxWidth={1279}
					>
						{Array.from({ length: 2 }).map((_, index) => renderColumn(index, 'tablet'))}
					</MediaQuery>
					<MediaQuery maxWidth={767}>{renderColumn(0)}</MediaQuery>
				</div>
			)}

			{isValidArray(projects) && projectsToShow <= projects.length && typeof onLoadMoreClick === 'function' && (
				<div className='z-3 mt-4 text-center md:absolute md:bottom-0 md:left-0 md:mt-0 md:w-full'>
					<Button
						color='primary-alt'
						onClick={onLoadMoreClick}
					>
						Load More Projects
					</Button>
				</div>
			)}
		</div>
	);
};

ProjectGalleryGrid.propTypes = {
	projects: PropTypes.array,
	projectsToShow: PropTypes.number,
	className: PropTypes.string,
	onLoadMoreClick: PropTypes.func,
};

export default ProjectGalleryGrid;
